import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/app/providers/theme-context';
import { IconButton } from './IconButton';

export interface ThemeToggleProps {
  className?: string;
  variant?: 'ghost' | 'secondary';
}

/** Przelacznik motywu jasny/ciemny. */
export function ThemeToggle({ className, variant = 'ghost' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <IconButton
      variant={variant}
      className={className}
      onClick={toggleTheme}
      icon={isDark ? <Sun /> : <Moon />}
      label={isDark ? 'Przełącz na motyw jasny' : 'Przełącz na motyw ciemny'}
      aria-pressed={isDark}
    />
  );
}
